import { useCallback, useEffect, useRef, useState } from 'react';

import { BaseToast } from '../../components/UI/Toast/types';

export type ToastOptions = BaseToast;

type ToastState = BaseToast & {
  isOpen: boolean;
};

export const useToast = () => {
  const isMountedRef = useRef(true);

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const [toastState, setToastState] = useState<ToastState>({
    isOpen: false,
    message: '',
  });

  const showToast = useCallback((options: ToastOptions) => {
    if (!isMountedRef.current) return;
    setToastState({ isOpen: true, ...options });
  }, []);

  const hideToast = useCallback(() => {
    if (!isMountedRef.current) return;
    setToastState((prev) => {
      prev.onDidDismiss?.();
      return { ...prev, isOpen: false };
    });
  }, []);

  return {
    toastState,
    showToast,
    hideToast,
  };
};
